"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _imageBox = require("./imageBox");
Object.keys(_imageBox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _imageBox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _imageBox[key];
    }
  });
});
var _price = require("./price");
Object.keys(_price).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _price[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _price[key];
    }
  });
});
var _root = require("./root");
Object.keys(_root).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _root[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _root[key];
    }
  });
});
//# sourceMappingURL=index.js.map